/* @flow */
import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { querystring } from '@/utils/common';

type Props = {
  component: React.ComponentType<any>,
  props: Object,
};

export default function UnauthenticatedRoute<C: React.ComponentType<Props>>({
  component: Component,
  props: cProps,
  ...rest
}: Props): React.Element<C> {
  const redirect = querystring('redirect');
  return (
    <Route
      {...rest}
      render={(props) =>
        !cProps.auth.isAuthorized ? (
          <Component {...props} {...cProps} />
        ) : (
          <Redirect to={redirect === '' || redirect === null ? '/' : redirect} />
        )
      }
    />
  );
}
